var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPlogging({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 499,
    viewBox: "0 0 331 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6633 127.56H66.3342V169.997H70.6633V127.56Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5678 115.087C69.0327 116.384 69.5905 117.702 70.2613 119.015C73.7638 125.859 79.2538 130.587 86.5829 133.061L88.6357 133.755L90 129.572L87.9447 128.878C71.9095 123.462 70.6633 106.936 70.6633 102H66.3342C66.4598 106.324 67.2387 110.689 68.5653 115.087H68.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4322 115.087C67.9673 116.384 67.4095 117.702 66.7387 119.015C63.2362 125.859 57.7462 130.587 50.4171 133.061L48.3643 133.755L47 129.574L49.0553 128.881C65.0879 123.462 66.3342 106.936 66.3342 102H70.6633C70.5377 106.324 69.7588 110.689 68.4322 115.087Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5678 127.87C69.0327 129.167 69.5905 130.485 70.2613 131.798C73.7638 138.642 79.2538 143.37 86.5829 145.844L88.6357 146.538L90 142.354L87.9447 141.661C71.9095 136.242 70.6633 119.718 70.6633 114.783H66.3342C66.4598 119.107 67.2387 123.472 68.5653 127.87H68.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4322 127.87C67.9673 129.167 67.4095 130.485 66.7387 131.798C63.2362 138.642 57.7462 143.37 50.4171 145.844L48.3643 146.538L47 142.354L49.0553 141.661C65.0905 136.242 66.3367 119.718 66.3367 114.783H70.6658C70.5402 119.107 69.7613 123.472 68.4347 127.87H68.4322Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5678 140.65C69.0327 141.947 69.5905 143.265 70.2613 144.578C73.7638 151.422 79.2538 156.15 86.5829 158.624L88.6357 159.318L90 155.134L87.9447 154.441C71.9095 149.022 70.6633 132.499 70.6633 127.563H66.3342C66.4598 131.887 67.2387 136.252 68.5653 140.65H68.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4322 140.65C67.9673 141.947 67.4095 143.265 66.7387 144.578C63.2362 151.422 57.7462 156.15 50.4171 158.624L48.3643 159.318L47 155.134L49.0553 154.441C65.0905 149.022 66.3367 132.499 66.3367 127.563H70.6658C70.5402 131.887 69.7613 136.252 68.4347 140.65H68.4322Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.663 175.56H135.334V217.997H139.663V175.56Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.568 163.087C138.033 164.384 138.59 165.702 139.261 167.015C142.764 173.859 148.254 178.587 155.583 181.061L157.636 181.755L159 177.572L156.945 176.878C140.91 171.462 139.663 154.936 139.663 150H135.334C135.46 154.324 136.239 158.689 137.565 163.087H137.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.432 163.087C136.967 164.384 136.41 165.702 135.739 167.015C132.236 173.859 126.746 178.587 119.417 181.061L117.364 181.755L116 177.574L118.055 176.881C134.088 171.462 135.334 154.936 135.334 150H139.663C139.538 154.324 138.759 158.689 137.432 163.087Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.568 175.87C138.033 177.167 138.59 178.485 139.261 179.798C142.764 186.642 148.254 191.37 155.583 193.844L157.636 194.538L159 190.354L156.945 189.661C140.91 184.242 139.663 167.718 139.663 162.783H135.334C135.46 167.107 136.239 171.472 137.565 175.87H137.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.432 175.87C136.967 177.167 136.41 178.485 135.739 179.798C132.236 186.642 126.746 191.37 119.417 193.844L117.364 194.538L116 190.354L118.055 189.661C134.09 184.242 135.337 167.718 135.337 162.783H139.666C139.54 167.107 138.761 171.472 137.435 175.87H137.432Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.568 188.65C138.033 189.947 138.59 191.265 139.261 192.578C142.764 199.422 148.254 204.15 155.583 206.624L157.636 207.318L159 203.134L156.945 202.441C140.91 197.022 139.663 180.499 139.663 175.563H135.334C135.46 179.887 136.239 184.252 137.565 188.65H137.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.432 188.65C136.967 189.947 136.41 191.265 135.739 192.578C132.236 199.422 126.746 204.15 119.417 206.624L117.364 207.318L116 203.134L118.055 202.441C134.09 197.022 135.337 180.499 135.337 175.563H139.666C139.54 179.887 138.761 184.252 137.435 188.65H137.432Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.663 25.5604H246.334V67.9974H250.663V25.5604Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.568 13.0873C249.033 14.3845 249.59 15.7022 250.261 17.0147C253.764 23.859 259.254 28.5873 266.583 31.0614L268.636 31.7548L270 27.5715L267.945 26.8781C251.91 21.4616 250.663 4.93555 250.663 0H246.334C246.46 4.32404 247.239 8.68902 248.565 13.0873H248.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.432 13.0873C247.967 14.3845 247.41 15.7022 246.739 17.0147C243.236 23.859 237.746 28.5873 230.417 31.0614L228.364 31.7548L227 27.5741L229.055 26.8807C245.088 21.4616 246.334 4.93555 246.334 0H250.663C250.538 4.32404 249.759 8.68902 248.432 13.0873Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.568 25.8701C249.033 27.1673 249.59 28.485 250.261 29.7976C253.764 36.6418 259.254 41.3701 266.583 43.8443L268.636 44.5377L270 40.3543L267.945 39.661C251.91 34.2418 250.663 17.7184 250.663 12.7828H246.334C246.46 17.1069 247.239 21.4719 248.565 25.8701H248.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.432 25.8701C247.967 27.1673 247.41 28.485 246.739 29.7976C243.236 36.6418 237.746 41.3701 230.417 43.8443L228.364 44.5377L227 40.3543L229.055 39.661C245.09 34.2418 246.337 17.7184 246.337 12.7828H250.666C250.54 17.1069 249.761 21.4719 248.435 25.8701H248.432Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.568 38.6502C249.033 39.9475 249.59 41.2651 250.261 42.5777C253.764 49.422 259.254 54.1503 266.583 56.6244L268.636 57.3178L270 53.1345L267.945 52.4411C251.91 47.022 250.663 30.4985 250.663 25.563H246.334C246.46 29.887 247.239 34.252 248.565 38.6502H248.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.432 38.6502C247.967 39.9475 247.41 41.2651 246.739 42.5777C243.236 49.422 237.746 54.1503 230.417 56.6244L228.364 57.3178L227 53.1345L229.055 52.4411C245.09 47.022 246.337 30.4985 246.337 25.563H250.666C250.54 29.887 249.761 34.252 248.435 38.6502H248.432Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.663 262.56H307.334V304.997H311.663V262.56Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.568 250.087C310.033 251.384 310.59 252.702 311.261 254.015C314.764 260.859 320.254 265.587 327.583 268.061L329.636 268.755L331 264.572L328.945 263.878C312.91 258.462 311.663 241.936 311.663 237H307.334C307.46 241.324 308.239 245.689 309.565 250.087H309.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.432 250.087C308.967 251.384 308.41 252.702 307.739 254.015C304.236 260.859 298.746 265.587 291.417 268.061L289.364 268.755L288 264.574L290.055 263.881C306.088 258.462 307.334 241.936 307.334 237H311.663C311.538 241.324 310.759 245.689 309.432 250.087Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.568 262.87C310.033 264.167 310.59 265.485 311.261 266.798C314.764 273.642 320.254 278.37 327.583 280.844L329.636 281.538L331 277.354L328.945 276.661C312.91 271.242 311.663 254.718 311.663 249.783H307.334C307.46 254.107 308.239 258.472 309.565 262.87H309.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.432 262.87C308.967 264.167 308.41 265.485 307.739 266.798C304.236 273.642 298.746 278.37 291.417 280.844L289.364 281.538L288 277.354L290.055 276.661C306.09 271.242 307.337 254.718 307.337 249.783H311.666C311.54 254.107 310.761 258.472 309.435 262.87H309.432Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.568 275.65C310.033 276.947 310.59 278.265 311.261 279.578C314.764 286.422 320.254 291.15 327.583 293.624L329.636 294.318L331 290.134L328.945 289.441C312.91 284.022 311.663 267.499 311.663 262.563H307.334C307.46 266.887 308.239 271.252 309.565 275.65H309.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.432 275.65C308.967 276.947 308.41 278.265 307.739 279.578C304.236 286.422 298.746 291.15 291.417 293.624L289.364 294.318L288 290.134L290.055 289.441C306.09 284.022 307.337 267.499 307.337 262.563H311.666C311.54 266.887 310.761 271.252 309.435 275.65H309.432Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.663 304.56H221.334V346.997H225.663V304.56Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.568 292.087C224.033 293.384 224.59 294.702 225.261 296.015C228.764 302.859 234.254 307.587 241.583 310.061L243.636 310.755L245 306.572L242.945 305.878C226.91 300.462 225.663 283.936 225.663 279H221.334C221.46 283.324 222.239 287.689 223.565 292.087H223.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.432 292.087C222.967 293.384 222.41 294.702 221.739 296.015C218.236 302.859 212.746 307.587 205.417 310.061L203.364 310.755L202 306.574L204.055 305.881C220.088 300.462 221.334 283.936 221.334 279H225.663C225.538 283.324 224.759 287.689 223.432 292.087Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.568 304.87C224.033 306.167 224.59 307.485 225.261 308.798C228.764 315.642 234.254 320.37 241.583 322.844L243.636 323.538L245 319.354L242.945 318.661C226.91 313.242 225.663 296.718 225.663 291.783H221.334C221.46 296.107 222.239 300.472 223.565 304.87H223.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.432 304.87C222.967 306.167 222.41 307.485 221.739 308.798C218.236 315.642 212.746 320.37 205.417 322.844L203.364 323.538L202 319.354L204.055 318.661C220.09 313.242 221.337 296.718 221.337 291.783H225.666C225.54 296.107 224.761 300.472 223.435 304.87H223.432Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.568 317.65C224.033 318.947 224.59 320.265 225.261 321.578C228.764 328.422 234.254 333.15 241.583 335.624L243.636 336.318L245 332.134L242.945 331.441C226.91 326.022 225.663 309.499 225.663 304.563H221.334C221.46 308.887 222.239 313.252 223.565 317.65H223.568Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.432 317.65C222.967 318.947 222.41 320.265 221.739 321.578C218.236 328.422 212.746 333.15 205.417 335.624L203.364 336.318L202 332.134L204.055 331.441C220.09 326.022 221.337 309.499 221.337 304.563H225.666C225.54 308.887 224.761 313.252 223.435 317.65H223.432Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_13_53284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6633 456.56H95.3342V498.997H99.6633V456.56Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5678 444.087C98.0327 445.384 98.5905 446.702 99.2613 448.015C102.764 454.859 108.254 459.587 115.583 462.061L117.636 462.755L119 458.572L116.945 457.878C100.91 452.462 99.6633 435.936 99.6633 431H95.3342C95.4598 435.324 96.2387 439.689 97.5653 444.087H97.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4322 444.087C96.9673 445.384 96.4095 446.702 95.7387 448.015C92.2362 454.859 86.7462 459.587 79.4171 462.061L77.3643 462.755L76 458.574L78.0553 457.881C94.0879 452.462 95.3342 435.936 95.3342 431H99.6633C99.5377 435.324 98.7588 439.689 97.4322 444.087Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5678 456.87C98.0327 458.167 98.5905 459.485 99.2613 460.798C102.764 467.642 108.254 472.37 115.583 474.844L117.636 475.538L119 471.354L116.945 470.661C100.91 465.242 99.6633 448.718 99.6633 443.783H95.3342C95.4598 448.107 96.2387 452.472 97.5653 456.87H97.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4322 456.87C96.9673 458.167 96.4095 459.485 95.7387 460.798C92.2362 467.642 86.7462 472.37 79.4171 474.844L77.3643 475.538L76 471.354L78.0553 470.661C94.0905 465.242 95.3367 448.718 95.3367 443.783H99.6658C99.5402 448.107 98.7613 452.472 97.4347 456.87H97.4322Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5678 469.65C98.0327 470.947 98.5905 472.265 99.2613 473.578C102.764 480.422 108.254 485.15 115.583 487.624L117.636 488.318L119 484.134L116.945 483.441C100.91 478.022 99.6633 461.499 99.6633 456.563H95.3342C95.4598 460.887 96.2387 465.252 97.5653 469.65H97.5678Z",
    fill: "#469046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4322 469.65C96.9673 470.947 96.4095 472.265 95.7387 473.578C92.2362 480.422 86.7462 485.15 79.4171 487.624L77.3643 488.318L76 484.134L78.0553 483.441C94.0905 478.022 95.3367 461.499 95.3367 456.563H99.6658C99.5402 460.887 98.7613 465.252 97.4347 469.65H97.4322Z",
    fill: "#469046"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-4 384.891C8.9432 384.891 15.9503 379 27.5499 379C38.1043 379 43.9788 384.891 56.857 384.891C74.0973 384.891 78.3879 380.168 88.1278 380.168",
    stroke: "#3C7FB3",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 409.891C34.9432 409.891 41.9503 404 53.5499 404C64.1043 404 69.9788 409.891 82.857 409.891C100.097 409.891 104.388 405.168 114.128 405.168",
    stroke: "#3C7FB3",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(47 102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(116 150)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(288 237)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(202 279)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_13_53284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 68,
    fill: "white",
    transform: "translate(76 431)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlogging);
export default __webpack_public_path__ + "static/media/bg_plogging.8e88e257f5fb29984baf59d44a63d27a.svg";
export { ForwardRef as ReactComponent };